// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.taskCreator {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    row-gap: 12px;
    padding: 24px;
    border-radius: 12px;
    border-width: 1px;
    border-color: #CCC;
    border-style: solid;
    background-color: white;
}

.delete {
    position: absolute;
    top: 6px;
    right: 6px;
    cursor: pointer;
}

.row {
    display: flex;
    flex-direction: row;
    column-gap: 12px;
}

.imagesButton {
    background-color: #ecb639;
    border-style: solid;
    border-width: 1px;
    border-color: #CCCCCC;
    width: 100%;
    padding: 12px 12px;
    border-radius: 8px;
    cursor: pointer;
}

.imagesButton:hover {
    background-color: #e0ad3a;
    transition: background-color 250ms ease-in-out;
}

.imagesButton:active {
    background-color: #eab84c;
    transition: background-color 250ms ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/pages/CreateExercise/components/TaskCreator.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,yBAAyB;IACzB,8CAA8C;AAClD","sourcesContent":[".taskCreator {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    row-gap: 12px;\n    padding: 24px;\n    border-radius: 12px;\n    border-width: 1px;\n    border-color: #CCC;\n    border-style: solid;\n    background-color: white;\n}\n\n.delete {\n    position: absolute;\n    top: 6px;\n    right: 6px;\n    cursor: pointer;\n}\n\n.row {\n    display: flex;\n    flex-direction: row;\n    column-gap: 12px;\n}\n\n.imagesButton {\n    background-color: #ecb639;\n    border-style: solid;\n    border-width: 1px;\n    border-color: #CCCCCC;\n    width: 100%;\n    padding: 12px 12px;\n    border-radius: 8px;\n    cursor: pointer;\n}\n\n.imagesButton:hover {\n    background-color: #e0ad3a;\n    transition: background-color 250ms ease-in-out;\n}\n\n.imagesButton:active {\n    background-color: #eab84c;\n    transition: background-color 250ms ease-in-out;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
